
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
import edit from './RevAccountEdit.vue';
import QRCode from 'qrcodejs2'
@Component({
    components: { edit }
})
export default class suppliermanage extends pagelist {
    get prox() {
        return new proxy.MerchantRevAccountServiceProxy();
    }
    input: proxy.MerchantRevAccountPageInputDto = new proxy.MerchantRevAccountPageInputDto();
    sub_id = 0;
    createOrEditShow = false;
    qrcodeshow = false;
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },

        {
            title: '姓名',
            key: 'bankName'
        },
        // {
        //     title: '支付宝名称',
        //     key: 'aliName'
        // },
        {
            title:'银行卡号',
            key:'bankNo'
        },
        {
            title:'银行',
            key:'bank'
        },
        {
            title:"支行名称",
            key:'bankZhiHang'
        },
        {
            title:'所属省份',
            key:'bankProvince'
        }
    ];
    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
        this.prox.queryModelList(this.input).then(x => {
            console.log(x.items);
            this.dataList = x.items;
            this.showPaging(x);
        });
    }
    
    getpage() {
        this.OnInit();
    }
    async created() {
        this.getpage();
    }
    create() {
        this.createOrEditShow = true;
        this.sub_id = undefined;
    }
    edit(row) {
        if (!row) {
            if (this.selectedDataItems.length == 0) {
                this.$Notice.error({ title: '请选中一条数据' });
                return;
            }
            row = this.selectedDataItems[0];
        }
        this.sub_id = row.id;
        this.createOrEditShow = true;
    }

    del() {
        if (this.selectedDataItems.length == 0) {
            this.$Notice.error({ title: '请至少选中一条数据' });
            return;
        }
        this.$Modal.confirm({
            title: '你确定要删除吗?删除后将无法恢复',
            onOk: () => {
                var ids = this.selectedDataItems.map(x => {
                    return x.id;
                });
                this.prox.deletes(ids).then(() => {
                    this.$Notice.success({ title: '删除成功' });
                    this.getpage();
                });
            }
        });
    }
}
